import o from "./highrise1302.mjs";
import e from "./highrise1303.mjs";
import t from "./highrise1299.mjs";
import m from "./highrise1301.mjs";
function s(r) {
  return t(r) ? o(m(r)) : e(r);
}
export {
  s as default
};
